module.exports = [
  null,
  'logic pro',
  'garageband',
  'reason ',
  'pro tool',
  'live',
  'reaper',
  'fl studio',
  'cubase',
  'studio one'
];